module.exports = __webpack_public_path__ + "media/country_flags/ye-f1990775.png";